import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Admin } from '../../../../model/admin';
import { merge } from 'lodash-es';
import { ApiResponse } from '../../../../classes/api-response';
import { UsersService } from '../../../../services/users.service';
import { SnackService } from '../../../../services/snack.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'aw-admin-form',
  templateUrl: './admin-form.component.html',
  styleUrls: ['./admin-form.component.scss']
})
export class AdminFormComponent implements OnInit {

  userForm: UntypedFormGroup;
  @Output() saved = new EventEmitter<void>();
  @Output() canceled = new EventEmitter<void>();
  saving = false;
  generalError?: ApiResponse;
  previousUrl: string = '';

  constructor(
    private userService: UsersService,
    private snackService: SnackService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    if (route.snapshot.url[0])
      this.previousUrl = route.snapshot.url[0].path;
    this.userForm = new UntypedFormGroup(
      {
        email: new UntypedFormControl(
          '',
          [
            Validators.pattern("[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?"),
            Validators.required
          ]
        ),
        firstName: new UntypedFormControl(
          '',
          [
            Validators.required,
          ]
        ),
        lastName: new UntypedFormControl(
          '',
          [
            Validators.required,
          ]
        ),
        phone: new UntypedFormControl(
          '',
          [
            Validators.pattern('[- +()0-9]+'),
            Validators.required
          ]
        )
      },
    );
  }

  _admin = new Admin();

  @Input() set admin(value: Admin) {
    this._admin = merge(new Admin(), value);
    this.userForm.patchValue(this._admin);
    if (value.id) {
      this.userForm.controls.email.disable();
    }
  }

  ngOnInit(): void {
  }

  saveUser(): void {

    this.saving = true;

    const newUser = merge(new Admin(), this._admin, this.userForm.value);

    this.generalError = undefined;

    if (this._admin.id) {
      this.userService.updateAdmin(newUser)
        .subscribe(
          () => {
            this.saving = false;
            this.admin = newUser;
            this.snackService.success('Administrator updated!');
            this.saved.emit();
          },
          error => {
            this.saving = false;
            this.snackService.error(error.message);
            this.generalError = error;
          });
    } else {
      this.userService.createAdmin(newUser)
        .subscribe(
          () => {
            this.saving = false;
            this.admin = newUser;
            this.snackService.success('Administrator created!');
            this.saved.emit();
          },
          error => {
            this.saving = false;
            this.snackService.error(error.message);
            this.generalError = error;
          });
    }

  }

  onCancel():void {

    if(this.previousUrl === 'edit')
      this.router.navigateByUrl("/reserved/profile")
    this.admin = this._admin;
    this.canceled.emit();

  }




}
